import request from "@/utils/request";

export default function agencyGetNotReadLogisticsMessageNum() {
    return request({
        url: `/logisticsMessage/agencyGetNotReadMessageNum/`,
        method: 'get',
    })
}
